function animateShippingBarFill() {
  document.querySelectorAll('.cart-drawer__shipping-bar-fill').forEach((fill) => {
    const target = fill.style.width;
    fill.style.transition = 'none';
    fill.style.width = '0%';
    // eslint-disable-next-line no-unused-expressions
    fill.offsetWidth; // force reflow so the browser registers the 0% state before animating
    requestAnimationFrame(() => {
      fill.style.transition = '';
      fill.style.width = target;
    });
  });
}

document.addEventListener('DOMContentLoaded', animateShippingBarFill);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    requestAnimationFrame(animateShippingBarFill);
  });
}
